import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import cx from 'classnames';
import _ from 'lodash';
import dateformat from "dateformat";
import TruncatedTextWithTooltip from 'components/TruncatedTextWithTooltip';

import { fetchingJourneyReports } from 'actions/storyboardReports';
import { convertDatesToTimezone } from 'services/report.service';
import { EmptyMessage, JourneyAnalyticsHeader, LoadingMessage, TableInfo } from '.';
import { TableFooter } from './tableFooter';

import { useReportType } from '../ReportsProvider';
import styles from '../report.module.scss';

export function JourneyAnalytics(props) {
  const dispatch = useDispatch();

  let { storyboardId } = useParams();
  const data = useSelector(state => _.get(state, `storyboards.storyboard.reports.journey.items`));
  const pagination = useSelector(state => _.get(state, `storyboards.storyboard.reports.journey.pagination`));
  const loading = useSelector(state => _.get(state, 'storyboards.storyboard.reports.journey.loading'));
  const [currentChart, setCurrentChart] = useState("table_view");
  const { reportType } = useReportType()

  useEffect(() => {
    if (props.date) {
      handlePageChange(0);
    }
  }, [props.date, reportType]);

  const handlePageChange = (page) => {
    var request = {
      storyboard: storyboardId,
      reportType,
      ...convertDatesToTimezone(props.date),
    }

    dispatch(fetchingJourneyReports(request, page, 5));
  }


  const handleChartChange = (value) => {
    setCurrentChart(value)
  }

  return (
    <div className={styles.journeyAnalyticsWrapper}>
      <div className={styles.journeyAnalyticsContainer}>

        <TableInfo
          name="Journey Analytics"
          pagination={pagination} />

        <JourneyAnalyticsHeader />

        {!loading && data && data.map((data, index) => {
            return <JourneyReportView data={data} loading={loading} storyboard={storyboardId} index={index} storyboardType={props.storyboardType} date={props.date}/>
          })
        }

        {loading && (data && data.length > 0) &&
          <LoadingMessage />
        }

        {(data && data.length == 0) && !loading &&
          <EmptyMessage />
        }

      </div>

      <TableFooter
        currentChart={currentChart}
        disableView={['graph_view', 'pie_chart_view', 'table_view']}
        handleChartChange={handleChartChange}
        handlePageChange={handlePageChange}
        pagination={pagination}
        paginationName={"Journeys"}
      />
    </div>
  )
}

function JourneyReportView({ loading, storyboard, data, storyboardType, date }) {
  
  if (!data || data.length <= 1) {
    return false;
  }

  return (
    <div className={styles.journeyAnalyticsRow}>

      <div className={cx(styles.wrapper, styles.locationColumn)}>
        <div className={styles.headline}>
            <TruncatedTextWithTooltip content={data.name} maxWidth={230} placement='top'/>
        </div>
      </div>

      <div className={cx(styles.wrapper, styles.viewsColumn)}>
        <div className={styles.headline}>{dateformat(data.createdDate, 'dd mmm yyyy')}</div>
      </div>

      <div className={cx(styles.wrapper, styles.visitorsColumn)}>
        <div className={styles.headline}>{data.views}</div>
      </div>

      <div className={cx(styles.wrapper, styles.visitorsColumn)}>
        <div className={styles.headline}>{data.visitors}</div>
      </div>

      <div className={cx(styles.wrapper, styles.avgTimeSpentColumn)}>
        <div className={styles.headline}>{data.leads}</div>
      </div>

      <div className={cx(styles.wrapper, styles.timespentColumn)}>
        <div className={styles.headline}>{`${data.completion}%`}</div>
      </div>
    </div>
  )
}